import WorkScheduleModal from './work-schedule-modal-container'

export default WorkScheduleModal
